/* global $:false */

import Dropzone from 'dropzone/dist/min/dropzone.min.js'

export default class Valuation {
  static init () {
    Array.from($('.js-valuation-form')).map((el) =>
      new Valuation(el))
  }

  constructor (el) {
    this.validateFields = this.validateFields.bind(this)
    this.el = $(el)
    this.findElements()
    this.loadDropzone()
    this.setupBindings()
  }

  findElements () {
    this.inputFields = this.el.find('[aria-required]')
    this.recaptcha = this.el.find('[data-recaptcha]')
  }

  loadDropzone () {
    Dropzone.autoDiscover = false
    const dropzone = new Dropzone('[data-item-images]', {
      maxFiles: 8,
      maxFilesize: 15,
      addRemoveLinks: true,
      dictCancelUpload: this.el.data('dict-cancel-upload'),
      dictCancelUploadConfirmation: this.el.data('dict-cancel-upload-confirmation'),
      dictRemoveFile: this.el.data('dict-remove-file'),
      dictMaxFilesExceeded: this.el.data('dict-max-files-exceeded')
    })
    dropzone.on('success', (file, serverResponse) => {
      $('[data-dropzone-form]').prepend(
        `<input type='hidden' data-filename='${file.name}' name='uploaded_images[names][]' value=${serverResponse.sanitized_file_name}>`
      )
      this.validateFields()
    })

    dropzone.on('removedfile', file => $(`input[name^=uploaded_images][data-filename='${file.name}']`).remove())
  }

  setupBindings () {
    this.inputFields.change(() => {
      this.validateFields()
    })
  }

  validateFields () {
    if (this.el.find('[data-filename]').length === 0) { return }
    for (const field of Array.from(this.inputFields)) {
      if ($(field).val().length === 0) { return }
    }
    this.recaptcha.show()
  }
}
